/*
 * @Author: Chao Yang
 * @Date: 2020-10-19 15:46:35
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-10-20 09:57:13
 */
import {
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { IAdSelectButtonOption } from '../ad-select-button/i-ad-select-button-option.model';

@Component({
  selector: 'ad-toggle-button',
  templateUrl: './ad-toggle-button.component.html',
  styleUrls: ['./ad-toggle-button.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AdToggleButtonComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdToggleButtonComponent implements ControlValueAccessor, OnInit {
  options: IAdSelectButtonOption[];
  value = false;
  @Output() onOptionClick: EventEmitter<any> = new EventEmitter();
  @Output() onChange: EventEmitter<any> = new EventEmitter();
  onModelChange = (v) => {};
  onModelTouched = (v) => {};

  constructor(public cd: ChangeDetectorRef) {}

  writeValue(obj: any): void {
    this.value = obj;
    this.cd.markForCheck();
  }

  registerOnChange(fn: any): void {
    this.onModelChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onModelTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {}

  change(e: any): void {
    this.onChange.emit(e);
    this.onModelChange(this.value);
  }

  ngOnInit(): void {
    this.options = [
      {
        label: 'Yes',
        value: true,
      },
      {
        label: 'No',
        value: false,
      },
    ];
  }

  optionClick(e: any): void {
    this.onOptionClick.emit(e);
    this.onModelChange(this.value);
  }
}
